export default [
  {
    title: 'Informations éditeur',
    text: `
<p>
  Le site www.spiadi.fr est la propriété du CPias Centre-Val de Loire,
  porteur de la mission nationale SPIADI.
</p>

<p class="text-justify">
  <strong>CPias Centre-Val de Loire</strong><br>
  <strong>Centre Hospitalier Régional Universitaire de Tours</strong><br>
  2 Boulevard Tonnellé<br>
  37044 Tours Cedex
</p>`
  },
  {
    title: 'Création, réalisation et hébergement',
    text: `
<p>
  Création et réalisation du site www.spiadi.fr :
</p>
<p class="text-justify"></p>
  <strong>CPias Centre-Val de Loire</strong>
</p>
<p>
Hébergement du site et des données :
</p>
<p class="text-justify">
  L'outil web développé par le CPias Centre-Val de Loire et la base de données
  nationales sont hébergés sur un serveur sécurisé pour les données de santé
  à caractère personnel. Le fournisseur du service d'hébergement est Cloud
  Santé. Dans le cadre de l'activité d'hébergeur de données, Cloud Santé
  fournit un système sécurisé d'hébergement conforme aux éxigences légales de
  l'article L. 1111-8 du Code de la Santé Publique et des textes règlementaires
  pris pour son application (décret n°2006-6 du 4 janvier 2006 et décret
  n°2018-137 du 26 février 2018).
</p>`
  },
  {
    title: 'Données issues des surveillances',
    text: `
<p class="text-justify">
    Par défaut, seul le responsable du programme peut accéder aux données
    de l'établissement concerné par la surveillance. Il peut ensuite autoriser
    d'autres utilisateurs à accéder à tout ou partie de ces données. Seul
    le CPias Centre-Val de Loire peut accéder à l'ensemble de la base
    nationale.
</p>`
  },
  {
    title:
      `Protection des données personnelles et respect de la loi du 6
       janvier 1978`,
    text: `
<p class="text-justify">
  La consultation du site www.spiadi.fr est possible sans que vous ayez
  à révéler votre identité ou toute autre information à caractère personnel
  vous concernant.
</p>
<p class="text-justify">
  Le CPias Centre-Val de Loire s’engage à respecter votre vie privée et à
  protéger les informations que vous lui communiquez. En particulier,
  les données personnelles collectées sur le site internet www.spiadi.fr sont
  destinées au bon fonctionnement de la mission nationale SPIADI. Elles sont
  confidentielles et traitées comme telles.
</p>
<p class="text-justify">
  Concernant les informations à caractère nominatif que vous seriez amené
  à nous communiquer, vous bénéficiez d’un droit d’accès et de rectification
  conformément à la loi française Informatique et Liberté n° 78-17
  du 6 janvier 1978.
</p>`
  },
  {
    title: 'Titularité des droits',
    text: `
<p class="text-justify">
  Tous les éléments de ce site sont la propriété des éditeurs de ce
  site, à l’exclusion des éléments émanant de partenaires. La protection du
  site relève, par conséquent, des législations nationales et internationales
  relatives au droit de la propriété intellectuelle. Dès lors, toute
  reproduction et/ou représentation et/ou rediffusion, en tout ou partie,
  sur tout support électronique ou non, présent ou futur, sont interdites
  sauf autorisation expresse et préalable effectuée auprès de l’éditeur.
</p> 
<p class="text-justify">
    Le CPias Centre-Val de Loire porteur de la mission SPIADI autorise tout site
    internet ou tout autre support à citer le site ou à mettre en place un lien
    hypertexte pointant vers l’adresse du site internet www.spiadi.fr.
    Cette autorisation ne s’applique pas aux sites diffusant des informations à
    caractère polémique, pornographique, xénophobe ou pouvant, dans une plus
    large mesure, porter atteinte à la sensibilité du plus grand nombre. 
</p>
<p class="text-justify">
    Le CPias Centre-Val de Loire porteur de la mission SPIADI se réserve le
    droit de demander la suppression d’un lien qu’elle estime non conforme à
    sa ligne éditoriale. Le CPias Centre-Val de Loire porteur de la mission
    SPIADI ne peut en aucun cas être tenu pour responsable de la mise à
    disposition d’un lien hypertexte à partir de ces sites, et ne peut supporter
    aucune responsabilité sur le contenu, les produits, les services, etc.
    disponibles sur ces sites ou à partir de ces sites.
</p>`
  }
]
